/** UTC calendar-day difference (later − earlier). */
export function diffDaysUtc(later: Date | string, earlier: Date | string): number {
  const a = new Date(later)
  const b = new Date(earlier)
  const dayMs = 24 * 60 * 60 * 1000
  const aDay = Date.UTC(a.getUTCFullYear(), a.getUTCMonth(), a.getUTCDate())
  const bDay = Date.UTC(b.getUTCFullYear(), b.getUTCMonth(), b.getUTCDate())
  return Math.round((aDay - bDay) / dayMs)
}

/** Days between end date and last booking date; null when no deadline is stored. */
export function computeBookingDeadlineDays(
  endDate?: string | Date | null,
  lastBookingDate?: string | Date | null,
): number | null {
  if (!endDate || !lastBookingDate) return null
  const diff = diffDaysUtc(endDate, lastBookingDate)
  return Math.max(0, diff)
}

export function isBookingDeadlineDaysProvided(value: unknown): boolean {
  if (value === null || value === undefined || value === '') return false
  const n = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(n) && n >= 0
}

export function parseBookingDeadlineDaysInput(value: string): number | null {
  const trimmed = value.trim()
  if (trimmed === '') return null
  const n = Number(trimmed)
  if (!Number.isFinite(n) || n < 0) return null
  return Math.floor(n)
}

/** endDate − days (UTC); empty string when days not provided or end date missing. */
export function computeLastBookingDateFromDays(
  endDate?: string | Date | null,
  days?: number | null,
): string {
  if (!endDate || !isBookingDeadlineDaysProvided(days)) return ''
  const n = Math.max(0, Math.floor(Number(days)))
  const d = new Date(endDate)
  d.setUTCDate(d.getUTCDate() - n)
  return d.toISOString()
}
